import { reducerWithInitialState } from "typescript-fsa-reducers"
import { userInfoActions } from "../actions/UserInfoAction"

interface DriverScopeIf {
  "IT-A自動車-特定特約コード": string
}

export interface DriverSelectIf {
  spouse: boolean
  dependents: boolean
  unmarried: boolean
  married: boolean
  consent: boolean
  friend: boolean
  servant: boolean
}

export interface UserInfoState {
  contractorAge: string
  youngestAge: string
  licenceColor: string
  purpose: string
  distance: string
  location: string
  driverScope: Array<DriverScopeIf>
  driverSelect: DriverSelectIf
  hadAccidents: string
  gradeDownAccident: string
  hadAccidentSelect: string
  nonFleetGrade: string
  hasAEB: string
}

const initialState: UserInfoState = {
  contractorAge: "",
  youngestAge: "",
  licenceColor: "",
  purpose: "",
  distance: "",
  location: "",
  driverScope: [
    { "IT-A自動車-特定特約コード": "" },
    { "IT-A自動車-特定特約コード": "" },
    { "IT-A自動車-特定特約コード": "" },
    { "IT-A自動車-特定特約コード": "" }
  ],
  driverSelect: {
    spouse: false,
    dependents: false,
    unmarried: false,
    married: false,
    consent: false,
    friend: false,
    servant: false
  },
  hadAccidents: "",
  gradeDownAccident: "",
  hadAccidentSelect: "",
  nonFleetGrade: "",
  hasAEB: ""
}
// Reduxを利用した画面間共通の被保険者情報state初期化処理
export const userInfoReducer = reducerWithInitialState(initialState)
  .case(userInfoActions.updateContractorAge, (state, contractorAge) => {
    return { ...state, contractorAge }
  })
  .case(userInfoActions.updateYoungestAge, (state, youngestAge) => {
    return { ...state, youngestAge }
  })
  .case(userInfoActions.updateLicenceColor, (state, licenceColor) => {
    return { ...state, licenceColor }
  })
  .case(userInfoActions.updatePurpose, (state, purpose) => {
    return { ...state, purpose }
  })
  .case(userInfoActions.updateDistance, (state, distance) => {
    return { ...state, distance }
  })
  .case(userInfoActions.updateLocation, (state, location) => {
    return { ...state, location }
  })
  .case(userInfoActions.updateDriverScope, (state, driverScope) => {
    return { ...state, driverScope }
  })
  .case(userInfoActions.updateDriverSelect, (state, driverSelect) => {
    return { ...state, driverSelect }
  })
  .case(userInfoActions.updateHadAccidents, (state, hadAccidents) => {
    return { ...state, hadAccidents }
  })
  .case(userInfoActions.updateNonFleetGrade, (state, nonFleetGrade) => {
    return { ...state, nonFleetGrade }
  })
  .case(userInfoActions.updateHasAEB, (state, hasAEB) => {
    return { ...state, hasAEB }
  })
  .case(userInfoActions.updateGradeDownAccident, (state, gradeDownAccident) => {
    return { ...state, gradeDownAccident }
  })
  .case(userInfoActions.updateHadAccidentSelect, (state, hadAccidentSelect) => {
    return { ...state, hadAccidentSelect }
  })
  .case(userInfoActions.reset, (state) => {
    // {...state, ...initialState}ではなぜかdriverSelectが初期化されないので
    const userInfo = {
      contractorAge: "",
      youngestAge: "",
      licenceColor: "",
      purpose: "",
      distance: "",
      location: "",
      driverScope: [],
      driverSelect: {
        spouse: false,
        dependents: false,
        unmarried: false,
        married: false,
        consent: false,
        friend: false,
        servant: false
      },
      hadAccidents: "",
      nonFleetGrade: "",
      hasAEB: "",
      gradeDownAccident: "",
      hadAccidentSelect: ""
    }
    return { ...state, ...userInfo }
  })
  .default((state) => {
    return state
  })
